var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-range-slider',{staticStyle:{"padding-top":"16px"},attrs:{"hint":_vm.$t('components.TimeFilterTab.hint'),"min":_vm.maxSelected[0],"max":_vm.maxSelected[1],"thumb-label":"always","persistent-hint":""},on:{"change":_vm.emitValue},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }